export const LABELS_CODES = {
    CUSTOMER_CHOICE: 'CUSTOMER_CHOICE',
    GIFT_IN_CART: 'GIFT_IN_CART',
    GROWING_DISCOUNT: 'GROWING_DISCOUNT',
    IN_STOCK: 'IN_STOCK',
    IS_NEW: 'IS_NEW',
    EXPERTS_CHOICE: 'EXPERTS_CHOICE',
    ONLINE_ONLY: 'ONLINE_ONLY',
    SUPER_PRICE: 'SUPER_PRICE',
};

export const PRODUCT_ART_LINK = '/catalog/vino/filter/art-1/';

export const INFO_CONTENT_ABSOLUTE_MIN_LINES = 2;
